import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import IDevice from "../../models/devices/IDevice";
import Status from "../../enums/Status";
import deviceService from "../../services/deviceService";
import { Col, Row } from "react-grid-system";
import Placeholder from "../../navigation/Placeholder";
import DeviceCard from "../card/DeviceCard";
import Error from "./Error";

export default function DeviceCards() {
    const { t } = useTranslation();

    const [devices, setDevices] = useState<IDevice[]>([]);
    const [status, setStatus] = useState<Status>(Status.LOADING);

    const load = () => {
        setStatus(Status.LOADING);
    
        loadDevices(setDevices)
            .then(() => setStatus(Status.LOAD_SUCCESS))
            .catch(() => setStatus(Status.LOAD_ERROR));
    };

    useEffect(load, []);

    return (
        <Row>
            <Col>
                <Row>
                    <Col>
                        <h2>{t("devices.titles.list")}</h2>
                    </Col>
                </Row>
                <Row>
                    {
                        status === Status.LOADING &&
                        <Placeholder />
                    }
                    {
                        status === Status.LOAD_ERROR &&
                        <Error />
                    }
                    {
                        status === Status.LOAD_SUCCESS &&
                        devices.map(device => <DeviceCard key={device.id} device={device} />)
                    }
                </Row>
            </Col>
        </Row>
    );
}

async function loadDevices(setDevices: (devices: IDevice[]) => void) {
    const devices = await deviceService.getDevices();
    setDevices(devices);
}